
import { Vue, Component, Prop } from 'vue-property-decorator';
import { types } from '../../api_types';
import T from '../../lang';
import arena_DiffView from './DiffView.vue';
import omegaup_OverlayPopup from '../OverlayPopup.vue';
import { ArenaCourseFeedback } from './Feedback.vue';
import arena_FeedbackCodeView from './FeedbackCodeView.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faChevronCircleUp,
  faChevronCircleDown,
} from '@fortawesome/free-solid-svg-icons';
library.add(faChevronCircleUp);
library.add(faChevronCircleDown);

interface GroupVisibility {
  [name: string]: boolean;
}

const EMPTY_FIELD = '∅';

@Component({
  components: {
    FontAwesomeIcon,
    'omegaup-arena-diff-view': arena_DiffView,
    'omegaup-overlay-popup': omegaup_OverlayPopup,
    'omegaup-arena-feedback-code-view': arena_FeedbackCodeView,
  },
})
export default class ArenaRunDetailsPopup extends Vue {
  @Prop() data!: types.RunDetails;
  @Prop({ default: () => new Map<number, ArenaCourseFeedback>() })
  feedbackMap!: Map<number, ArenaCourseFeedback>;
  @Prop({ default: () => new Map<number, ArenaCourseFeedback>() })
  feedbackThreadMap!: Map<number, ArenaCourseFeedback>;

  EMPTY_FIELD = EMPTY_FIELD;
  T = T;
  groupVisible: GroupVisibility = {};

  get language(): string | undefined {
    return this.data?.language;
  }

  get source(): string | undefined {
    return this.data?.source;
  }

  get shortGuid(): string {
    return this.data.guid.substring(0, 8);
  }

  toggle(group: string): void {
    const visible = this.groupVisible[group];
    this.$set(this.groupVisible, group, !visible);
  }

  showDataCase(
    cases: types.ProblemCasesContents,
    caseName: string,
    caseType: 'in' | 'out' | 'contestantOutput',
  ): string {
    return cases[caseName]?.[caseType] ?? EMPTY_FIELD;
  }

  shouldShowDiffs(caseName: string): boolean {
    return (
      this.data.show_diff === 'all' ||
      (caseName === 'sample' && this.data.show_diff === 'examples')
    );
  }

  getContestantOutput(cases: types.ProblemCasesContents, name: string): string {
    return cases[name]?.contestantOutput ?? '';
  }

  contestScore(problemCase: types.CaseResult): number {
    return problemCase.contest_score ?? problemCase.score;
  }

  onSaveFeedbackList(
    feedbackList: { lineNumber: number; feedback: string }[],
    guid: string,
  ) {
    this.$parent?.$parent?.$parent?.$parent?.$emit('save-feedback-list', {
      feedbackList,
      guid,
    });
  }

  onSubmitFeedbackThread(feedback: ArenaCourseFeedback, guid: string) {
    this.$parent?.$parent?.$parent?.$parent?.$emit('submit-feedback-thread', {
      feedback,
      guid,
    });
  }
}
